import { render, staticRenderFns } from "./UserManageDialog.vue?vue&type=template&id=9160c268&scoped=true&"
import script from "./UserManageDialog.vue?vue&type=script&lang=js&"
export * from "./UserManageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9160c268",
  null
  
)

export default component.exports